import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber, getSortIndicator } from '../../../utils/helpers';
import useSortedData from '../hooks/useSortedData';
import usePagination from '../hooks/usePagination';
import '../components/ContestInfo.css';
import './ParticipantsTable.css';
import './Tables.css';

const ParticipantsTableGolfRegistering = ({ contest }) => {
  const playersPerPage = 20;

  // Sort initially by salary descending
  const { sortedData: sortedPlayers, requestSort, sortConfig } = useSortedData(contest.players, 'salary', 'descending');

  // Use the usePagination hook for pagination
  const { currentItems: currentPlayers, nextPage, prevPage, currentPage } = usePagination(sortedPlayers, playersPerPage);

  return (
    <div className="participants-table-container">
      <div className="participants-table-header">
        <span className="participants-table-header-text">PLAYERS ({contest.players.length})</span>
      </div>
      <table className="participants-table-registering">
        <thead>
          <tr>
            <th onClick={() => requestSort('name')}>
              NAME {getSortIndicator(sortConfig, 'name')}
            </th>
            <th onClick={() => requestSort('sportSpecificData.worldRank')}>
              RANK {getSortIndicator(sortConfig, 'sportSpecificData.worldRank')}
            </th>
            <th onClick={() => requestSort('sportSpecificData.odds')}>
              ODDS {getSortIndicator(sortConfig, 'sportSpecificData.odds')}
            </th>
            {contest.format !== 'H2H' && contest.draftType !== 'Snake' && (
              <th onClick={() => requestSort('salary')}>
                SALARY {getSortIndicator(sortConfig, 'salary')}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {currentPlayers.map((player, index) => (
            <tr key={index}>
              <td>{player.name}</td>
              <td>{player.sportSpecificData?.worldRank || 'N/A'}</td>
              <td>{player.sportSpecificData?.odds ? `+${player.sportSpecificData.odds}` : 'N/A'}</td>
              {contest.format !== 'H2H' && contest.draftType !== 'Snake' && <td>${formatNumber(player.salary)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination-controls">
        <button onClick={prevPage} disabled={currentPage === 1}>
          Back
        </button>
        <button onClick={nextPage} disabled={currentPage * playersPerPage >= contest.players.length}>
          Next
        </button>
      </div>
    </div>
  );
};

ParticipantsTableGolfRegistering.propTypes = {
  contest: PropTypes.shape({
    players: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      salary: PropTypes.number,
      sportSpecificData: PropTypes.shape({
        worldRank: PropTypes.number,
        odds: PropTypes.number
      })
    })).isRequired,
    format: PropTypes.string.isRequired,
    draftType: PropTypes.string
  }).isRequired
};

export default ParticipantsTableGolfRegistering;
